import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyCapitalizationDto, UpsertCompanyCapitalizationRequest } from '../../models/api/companyCapitalizationDto';

@Injectable({
  providedIn: 'root'
})
export class CompanyCapitalizationService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<CompanyCapitalizationDto> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<CompanyCapitalizationDto>(`${this.apiUrl}/${companyId}/capitalizations`, { params });
  }

  upsert(companyId: string, request: UpsertCompanyCapitalizationRequest): Observable<CompanyCapitalizationDto> {
    return this.http.put<CompanyCapitalizationDto>(`${this.apiUrl}/${companyId}/capitalizations`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/capitalizations`, { params });
  }
}
